module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dOMUlv/tc-custom/9781911667940.jpg?1705233292870",
      "alt": "This image is the cover for the book Vegan Recipes from France"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Vegan Recipes from France\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("French food is regional, full of variety, and above all designed for enjoyment. But it is also traditionally rich in products of animal origin: meat, butter, cream, eggs, and cheese. Vegan Recipes from France translates all the French classics into vegan alternatives. You will discover many easy recipes to make, with simple ingredients.   The book starts with all the basic recipes that are the foundation of  French cooking such as stocks, baguette, brioche, croissants, béchamel, aioli, and cheese. There are recipes for delicious vegan appetizers such as soups, terrines, and many original salads. Main dishes offer a selection of tarts and tartlettes, gratins, omelettes, quiches, souffles, and crepes. Desserts provide mouth- watering vegan alternatives to such standards as mousse au chocolate, clafoutis, tarte tatin, pain perdu, gateau, and madeleines.   The dishes are sumptuously photographed showing all your favorite French dishes vegan-style.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kristina Arnold\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grub Street Cookery\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0